/* global axios */
import ApiClient from '../ApiClient';

class SaasCallsAPI extends ApiClient {
  constructor() {
    super('calls', { saas: true, accountScoped: true });
  }

  getContactCalls(contactId) {
    const url = `${this.url.replace('/calls', '')}/contacts/${contactId}/calls`;
    return axios.get(url);
  }

  transcribe(callId) {
    return axios.post(`${this.url}/${callId}/transcription`);
  }
}

export default new SaasCallsAPI();
